
<template>
    <div>
        <div class="setup-form p-5">
            <b-row>
                <b-col>
                    <h1 class="complete-account-setup-heading">Complete Account Setup</h1>
                    <p class="complete-account-setup-description">Tell us about your organization to get you started.</p>
                    <div>
                        <b-row>
                            <b-col>
                                <b-form-group
                                    id="company-name-fieldset"
                                    label-for="company-name"
                                    :invalid-feedback="errorMessage('name')"
                                    :state="isValid('name')"
                                >
                                    <template slot="label">
                                        Company Name
                                        <i class="ic-tooltip ml-1 d-inline-block" id="company-name-tooltip"></i>
                                        <b-popover target="company-name-tooltip" triggers="hover" content="Input your company name, as your customers know it. Please don’t include any spaces or special characters."></b-popover>
                                    </template>
                                    <b-form-input id="company-name" placeholder="Company Name" v-model="stepOneForm.company"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="planId != 5">
                            <b-col>
                                <b-form-group
                                    id="company-website-fieldset"
                                    label-for="company-website"
                                    :invalid-feedback="errorMessage('website')"
                                    :state="isValid('website')"
                                >
                                    <template slot="label">
                                        Company Website (Optional)
                                        <i class="ic-tooltip ml-1 d-inline-block" id="company-website-tooltip"></i>
                                        <b-popover target="company-website-tooltip" triggers="hover" content="Tell us your company website."></b-popover>
                                    </template>
                                    <b-form-input id="company-website" placeholder="Company Website (Optional)" v-model="stepOneForm.website"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="planId != 5">
                            <b-col>
                                <b-form-group
                                    id="rush-subdomain-fieldset"
                                    label-for="rush-subdomain"
                                    :invalid-feedback="errorMessage('subdomain')"
                                    :state="isValid('subdomain')"
                                >
                                    <template slot="label">
                                        RUSH Subdomain
                                        <i class="ic-tooltip ml-1 d-inline-block" id="rush-subdomain-tooltip"></i>
                                        <b-popover target="rush-subdomain-tooltip" triggers="hover" content="Input how your company appears in the RUSH URL. Please don’t include any spaces or special characters. "></b-popover>
                                    </template>
                                    <!-- <b-input-group :prepend="'rush.ph/'" :append="'Available'"> -->
                                    <b-input-group :prepend="'merchant.rush.ph/'" :append="subdomainStatus" v-bind:class="{ 'unavailable' : subdomainStatus == 'Unavailable' }" @input="checkSubdomain()">
                                        <b-form-input id="rush-subdomain" v-model="stepOneForm.subdomain" maxlength='30' ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <h3 class="in-the-loop mb-3">Want to stay in the loop with RUSH?</h3>
                                <b-form-group class="mb-2"  
                                >
                                    <b-form-checkbox v-model="stepOneForm.subscribe.newsletter">
                                        Subscribe to newsletter
                                    </b-form-checkbox>
                                </b-form-group>
                                <b-form-group
                                >
                                    <b-form-checkbox v-model="stepOneForm.subscribe.updates">
                                        Get updates on what’s new in RUSH
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    
                    
                </b-col>
                <b-col></b-col>
            </b-row>
        </div>
        <div class="button-wrapper px-5 py-3" v-bind:class="{ 'retain-height': subIsActive('/setup/start') }">
            <b-button variant="outline-secondary" v-show="!subIsActive('/setup/start')">
                Back
            </b-button>
            <!-- <b-button variant="primary" class="float-right" :to="'/setup/step-2'" @click="sendForm"> -->
            <b-button variant="primary" class="float-right" @click="sendForm" :disabled="loading">
                <span v-if="loading">Submitting...</span>
                <span v-else>Next</span>
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "start",
    data() {
        return {};
    },
    computed: {
        ...mapState("setup", [
            "subdomainStatus",
            "stepOneForm",
            "nextStep",
            "errors",
            "loading"
        ]),
        ...mapState("auth", ["planId"])
    },
    created() {
        this.$store.dispatch("setup/getStepOneDetails");
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        },
        checkSubdomain() {
            let param = this.stepOneForm.subdomain;

            if (param != "")
                this.$store.dispatch("setup/checkSubdomain", param);
            // return this.subdomainStatus;
        },
        async sendForm() {
            this.$store.dispatch("setup/resetErrors");
            if (this.subdomainStatus !== "Unavailable") {
                this.$store.dispatch("setup/saveStepOne", this.stepOneForm);
            } else {
                this.$store.dispatch("setup/domainIsTaken");
            }
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        }
    }
};
</script>
<style lang="scss">
</style>
